import clsx from "clsx";
import React, { FC } from "react";

type Props = {
  title: string;
  children: React.ReactNode;
  wrapTitle?: boolean;
  className?: string;
  titleClassName?: string;
  formClassName?: string;
  display?: boolean;
  ["data-test-id"]?: string;
};

export const FormGroup: FC<Props> = ({
  title,
  children,
  wrapTitle = false,
  className,
  titleClassName,
  formClassName,
  display,
  ...props
}) => {
  return (
    <div className={clsx("flex items-center", display === false ? "hidden" : "", className)}>
      <span
        className={clsx(
          wrapTitle ? "" : "whitespace-nowrap",
          titleClassName ?? "w-[90px] min-w-[90px]",
          "text-end px-[8px]"
        )}
      >
        {title}
      </span>
      <div className={clsx("flex-grow overflow-auto", formClassName)} data-test-id={props["data-test-id"]}>
        {children}
      </div>
    </div>
  );
};
